/* eslint-disable react/prop-types */
import classes from "./composed-view-eight.module.scss";
import Label from "@/components-library/widgets/label";
import Flex from "@/components-library/layout/flex";
import Grid from "@/components-library/layout/grid";
import CardViewListStepTwo from "@/composed-views/card-view-list-step-two";
import classNames from "classnames";
function ComposedViewEight({
  header,
  title,
  content,
  stepOne,
  stepTwo,
  stepThree,
  stepFour,
  stepFive,
  stepSix,
  stepSeven,
  stepEight,
  className,
}) {
  return (
    <Flex
      align="flex-start"
      direction="column"
      justify="flex-start"
      className={classNames(classes.container, className)}
    >
      {header && (
        <Label
          weight="bold"
          tag="h5"
          color="primary"
          align="start"
          className={classes.header}
        >
          {header}
        </Label>
      )}

      {title && (
        <Label
          weight="bold"
          tag="h2"
          color="secondary"
          align="start"
          className={classes.title}
        >
          {title}
        </Label>
      )}
      {content && (
        <Label align="start" size="md" color="secondary">
          {content}
        </Label>
      )}
      <Grid columns="1fr 1fr">
        <CardViewListStepTwo step={stepOne} />
        <CardViewListStepTwo step={stepTwo} />
      </Grid>
      <Grid columns="1fr 1fr">
        <CardViewListStepTwo step={stepThree} />
        <CardViewListStepTwo step={stepFour} />
      </Grid>
      <Grid columns="1fr 1fr">
        <CardViewListStepTwo step={stepFive} />
        <CardViewListStepTwo step={stepSix} />
      </Grid>
      <Grid columns="1fr 1fr">
        <CardViewListStepTwo step={stepSeven} />
        <CardViewListStepTwo step={stepEight} />
      </Grid>
    </Flex>
  );
}

export default ComposedViewEight;
